"use client";
import { useState } from "react";
import dynamic from "next/dynamic";
const FilterDropdown = dynamic(() => import("./FilterDropdown"));

type Category = "industries" | "projectTypes" | "technologies";

interface Option {
  name: string;
  slug: string;
}

interface FilterProps {
  isChanged: boolean;
  selectedFilters?: Record<Category, Option[]>; // optional for future use
  onFilterChange: (filters: Record<Category, Option[]>) => void;
  availableFilters: Record<Category, Option[]>;
}

const categoryDisplayNames: Record<Category, string> = {
  industries: "Industries",
  projectTypes: "Project Types",
  technologies: "Technologies",
};
const Filter: React.FC< FilterProps> = ({ isChanged,
  selectedFilters,
  availableFilters,
  onFilterChange,
 }) => {
  const [openId, setOpenId] = useState<string | null>(null);
  return (
    <div className="container">
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
        {(Object.keys(availableFilters) as Category[]).map(
          (category, index) => (
            <div key={category} className="w-full">
              <FilterDropdown
                // category={categoryDisplayNames[category]}
                id={category}
                isChanged={isChanged}
                selectedFilters={selectedFilters?.[category] || []}
                OnChecked={(val: Option[]) => {
                  const filters = {
                    industries: selectedFilters?.industries ?? [],
                    projectTypes: selectedFilters?.projectTypes ?? [],
                    technologies: selectedFilters?.technologies ?? [],
                  };
                  onFilterChange({ ...filters, [category]: val });
                }}
                title={categoryDisplayNames[category]}
                options={availableFilters[category]}
                isOpen={openId === category}
                onOpen={() => setOpenId(category)}
                onClose={() => setOpenId(null)}
                variant={index % 2 === 0 ? "blue" : "green"}
              />
            </div>
          ),
        )}
      </div>
    </div>
  );
};
export default Filter;
